import { axiosPSClient } from "@/api/PSApiOperations"
import { store } from "../store"
import { galleryIdAtom, workspaceIdAtom } from "./pixieset-state"
import { queryClient } from "@/api/constants"

export const setupGallerySubscribers = () => {
	const applyWorkspaceHeader = (workspaceId: string | null) => {
		if (workspaceId) {
			axiosPSClient.defaults.headers.common["X-PS-WS-ID"] = workspaceId
		} else {
			delete axiosPSClient.defaults.headers.common["X-PS-WS-ID"]
		}
	}

	store.sub(workspaceIdAtom, () => {
		try {
			const workspaceId = store.get(workspaceIdAtom)
			applyWorkspaceHeader(workspaceId)
		} catch (err) {
			console.error("Error in workspaceIdAtom subscription:", err)
		}
	})

	// Ensure header is set on startup when workspace is already persisted.
	applyWorkspaceHeader(store.get(workspaceIdAtom))

	store.sub(galleryIdAtom, () => {
		void queryClient.invalidateQueries({ queryKey: ["galleryPhotos"] })
	})
}
